import React from "react";
import { LayoutGrid, HardHat } from "lucide-react";
import { heroImage } from "../mock";

const Hero = ({ onQuote }) => {
  return (
    <section id="home" className="relative pt-20">
      <div className="relative h-[560px] md:h-[600px] overflow-hidden diagonal-bottom">
        <img
          src={heroImage}
          alt="Solar panels and electrical substation"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-gradient" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="max-w-2xl text-white fade-up">
            <span className="inline-block bg-[#F5B800] text-[#0f2a5c] text-[11px] md:text-xs font-bold tracking-wider px-4 py-2 rounded-md uppercase">
              Electrical Contractor & Solar Solutions
            </span>
            <h1 className="mt-6 text-4xl md:text-6xl font-extrabold leading-tight">
              Powering Today
              <br />
              For A <span className="text-[#F5B800]">Brighter Tomorrow</span>
            </h1>
            <p className="mt-5 text-base md:text-lg text-slate-100/90 max-w-lg">
              We provide reliable electrical contracting and solar solutions for homes, businesses, industries and farmers.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="#services"
                className="inline-flex items-center gap-3 bg-[#F5B800] hover:bg-[#e0a800] text-[#0f2a5c] font-semibold px-6 py-3.5 rounded-md shadow-lg transition-colors"
              >
                <span className="w-7 h-7 rounded bg-[#0f2a5c] flex items-center justify-center">
                  <LayoutGrid className="w-4 h-4 text-[#F5B800]" />
                </span>
                Our Services
              </a>
              <button
                onClick={onQuote}
                className="inline-flex items-center gap-3 bg-transparent border-2 border-white/90 hover:bg-white hover:text-[#0f2a5c] text-white font-semibold px-6 py-3 rounded-md transition-colors"
              >
                <HardHat className="w-5 h-5" />
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
